class ManagementReportController {
    constructor($window, $uibModal, $browser, toastr, $location, moment, ngProgressFactory, SettingsExService, UserDetailsApi, ReportUtilityServiceApi, ReportServiceApi, StateService, ReportUtils) {
        this.$onInit = () => {
            this.selectedTester = { Id: 0, Name: 'Unknown' };
            this.selectedSim = { Id: 0, Name: 'Unknown' };
            this.state = {
                linkFromName: true,
                showReport: false,
                showSpinner: true,
                showTesters: false,
                userDetails: null,
                userLabel: 'Testers',
                userPlaceholder: 'Select a tester',
                userDropdownPopoverText: 'Testers with test results',
                simPlaceholder: 'Select a Simulator',
                simDropdownPopoverText: 'Tester simulators with test results',
                showToolPanel: false,
                reportRequest: {
                    UserId: 0,
                    SimId: 0,
                    TestSuiteId: 0
                },
                DateFormats: {
                    DateTimeFormat: '',
                    DateFormat: '',
                    TimeFormat: ''
                },
                selectedTester: { Id: 0, Name: 'Unknown' },
                selectedSim: { Id: 0, Name: 'Unknown' },
                selectedUser: { Id: 0, Name: 'Unknown' },
                hideNav: _.startsWith(this.location.path(), '/Reports')
            };
            this.data = {
                managementReports: [],
                testers: [],
                testerSims: []
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.managementReport = {
                Id: 0,
                Name: '',
                Description: 'Management Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.showPopover = false;
            this.columnDefs = [
                {
                    headerName: 'User',
                    field: 'UserDescription',
                    sort: 'asc',
                    minWidth: 200,
                    cellRenderer: this.nameCellRenderer
                },
                {
                    headerName: 'Sim Name',
                    field: 'SimName',
                    minWidth: 150,
                    cellRenderer: this.simCellRenderer
                },
                {
                    headerName: 'Test Suite Name',
                    field: 'TestSuiteName',
                    minWidth: 200,
                    cellRenderer: this.suiteCellRenderer
                },
                {
                    headerName: 'Tests',
                    field: 'NumTests',
                    width: 60,
                    minWidth: 60,
                    filter: 'number',
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Pass',
                    field: 'Pass',
                    width: 60,
                    minWidth: 60,
                    filter: 'number',
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Fail',
                    field: 'Fail',
                    width: 60,
                    minWidth: 60,
                    filter: 'number',
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Untested',
                    field: 'Untested',
                    width: 90,
                    minWidth: 90,
                    filter: 'number',
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Pass%',
                    field: 'PassPercent',
                    width: 70,
                    minWidth: 70,
                    filter: 'number',
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Fail%',
                    field: 'FailPercent',
                    width: 70,
                    minWidth: 70,
                    filter: 'number',
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Untested%',
                    field: 'UntestedPercent',
                    width: 100,
                    minWidth: 100,
                    filter: 'number',
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Last Test (UTC)',
                    field: 'LatestTestDate',
                    width: 175,
                    minWidth: 155,
                    cellRenderer: this.timeCellRenderer,
                    sortable: true,
                    suppressMenu: true,
                    resizable: true,
                    suppressSizeToFit: true
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.showReport = true;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.UserDetails.get().then((response) => {
                    this.state.userDetails = response.data; // setup our user details
                    if (this.state.userDetails.IsProjectTester) {
                        this.columnDefs[0].headerName = 'Project';
                        this.gridOptions.api.setColumnDefs(this.columnDefs);
                        this.state.userLabel = 'Projects';
                        this.state.userPlaceholder = 'Select a project',
                            this.state.userDropdownPopoverText = 'Projects with test results',
                            this.state.simDropdownPopoverText = 'Project simulators with test results';
                    }
                    // Support sees all tester reports
                    if (this.state.userDetails.IsSupport ||
                        this.state.userDetails.IsProjectTester) {
                        let req = {
                            UserId: -1,
                            SimId: -1,
                            TestSuiteId: -1
                        };
                        this.ReportServiceApi.getManagementReport(req).then((response) => {
                            this.state.showSpinner = false;
                            this.traceProgress.complete();
                            this.data.managementReports = response.data;
                            // Create a list of testers/projects and select the first one
                            this.data.testers = this.ReportService.testers(this.data.managementReports) || [{ Id: 0, Name: 'No testers available' }];
                            if (this.state.userDetails.IsProjectTester) {
                                if (this.data.testers.length === 1 && this.data.testers[0].Id === 0) {
                                    this.data.testers[0].Name = `No ${this.state.userLabel} available`;
                                }
                                else if (this.data.testers.length > 1) {
                                    this.data.testers[0].Name = `All ${this.state.userLabel}`;
                                }
                            }
                            this.state.selectedUser = this.data.testers[0];
                            this.selectTester(this.data.testers[0]);
                            this.state.showTesters = true;
                            // Get the data
                            this.gridOptions.api.setRowData(this.data.managementReports);
                            this.gridOptions.api.sizeColumnsToFit();
                            return;
                        });
                    }
                    if (this.state.userDetails.IsTester || this.state.userDetails.IsGroupTester) {
                        let req = {
                            UserId: this.state.userDetails.Id,
                            SimId: -1,
                            TestSuiteId: -1
                        };
                        this.ReportServiceApi.getManagementReport(req).then((response) => {
                            this.state.showSpinner = false;
                            this.traceProgress.complete();
                            this.data.managementReports = response.data;
                            this.gridOptions.api.setRowData(this.data.managementReports);
                            this.gridOptions.api.sizeColumnsToFit();
                            return;
                        });
                    }
                    this.traceProgress.complete();
                }, () => {
                    this.traceProgress.complete();
                    this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                    this.window.location.href =
                        this.browser.baseHref() + 'account/login';
                    return;
                });
            });
            this.ReportServiceApi.getReportByName('ManagementReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.managementReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.exportCsv = () => {
            let reportName = this.ReportService.addDateToTitle(this.managementReport.Description + '.csv');
            let params = {
                fileName: reportName
                // customHeader: "Management Report generated on 31 Jan 2016\n"
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.createLink = (data, tooltip, action) => {
            let link = [
                '<span',
                'ng-if="!vm.state.linkFromName">',
                data,
                '</span><a ng-href=""',
                'class="space-top pointer"',
                'title="',
                tooltip,
                '"',
                'ng-if="vm.state.linkFromName"',
                'ng-click="',
                action,
                '">',
                data,
                '</a>'
            ].join(' ');
            return link;
        };
        this.timeCellRenderer = (row) => {
            const friendlyDate = this.moment(new Date(row.data.LatestTestDate)).format(this.state.DateFormats.DateTimeFormat);
            let tooltip = `View Trace Details for ${friendlyDate}`;
            let action = 'vm.caseTraceDetails(data)';
            return this.createLink(friendlyDate, tooltip, action);
        };
        this.autoSizeAll = () => {
            let allColumnIds = [];
            this.columnDefs.forEach((columnDef) => {
                allColumnIds.push(columnDef.field);
            });
            this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
        };
        this.nameCellRenderer = (row) => {
            let tooltip = `View ${this.managementReport.Description} Report for ${row.data.UserDescription}`;
            let action = 'vm.openTesterCertReport(data)';
            return this.createLink(row.data.UserDescription, tooltip, action);
        };
        this.simCellRenderer = (row) => {
            let tooltip = `View Trace Summary page for ${row.data.SimName}`;
            let action = 'vm.simTraceSummary(data)';
            return this.createLink(row.data.SimName, tooltip, action);
        };
        this.suiteCellRenderer = (row) => {
            let tooltip = `View Trace Summary page for ${row.data.TestSuiteName}`;
            let action = 'vm.suiteTraceSummary(data)';
            return this.createLink(row.data.TestSuiteName, tooltip, action);
        };
        this.buildTraceSummaryPath = (testerId, simId, suiteId) => {
            return suiteId
                ? [
                    'TraceSummarySource/ManagementReport/',
                    testerId,
                    '/',
                    simId,
                    '/',
                    suiteId
                ].join('')
                : [
                    'TraceSummarySource/ManagementReport/',
                    testerId,
                    '/',
                    simId
                ].join('');
        };
        this.selectTester = (tester) => {
            this.showPopover = false;
            if (this.data.testers[0] === undefined ||
                this.data.testers[0] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            // Initialise to first object in array and overwrite if object is defined
            this.state.selectedTester = this.data.testers[0];
            if (tester !== undefined ||
                (tester !== null &&
                    Object.prototype.toString.call(tester) ===
                        '[object Object]')) {
                this.state.selectedTester = tester;
            }
            let sims = this.ReportService.testerSims(this.data.managementReports, this.state.selectedTester.Id);
            this.data.testerSims = sims;
            this.selectSim(sims[0]);
        };
        this.selectSim = (sim) => {
            if (angular.isUndefined(sim)) {
                sim = { Id: 0, Name: 'All Sims' };
            }
            this.state.selectedSim = sim;
            let data = this.data.managementReports;
            let testerId = this.state.selectedTester.Id;
            let filteredData = this.ReportService.testerSimReport(data, testerId, sim.Id);
            this.gridOptions.api.setRowData(filteredData);
        };
        this.caseTraceDetails = (row) => {
            let mode = { view: false, run: false };
            let selectedItems = {
                // selectedTester: vm.state.selectedTester,
                selectedTester: { Id: row.UserId, Name: row.UserDescription },
                selectedSim: { Id: row.SimId, Name: row.SimName },
                selectedSuite: { Id: row.TestSuiteId, Name: row.TestSuiteName },
                selectedTest: {
                    Id: row.LatestTestCaseId,
                    Name: row.LatestTestCaseName
                },
                unknownUser: { Id: 0, Name: 'Unknown' },
                fromTester: false
            };
            this.openDetails(selectedItems, mode);
        };
        this.openDetails = (selectedItems, mode) => {
            let tdParams = {
                selectedItems: selectedItems,
                mode: mode,
                user: this.state.userDetails,
                overTheShoulder: false
            };
            let modalInstance = this.uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                keyboard: false,
                component: 'traceDetailsModal',
                resolve: {
                    params: () => {
                        return tdParams;
                    }
                }
            });
        };
        this.openTesterCertReport = (params) => {
            let loggedInUserId = this.state.userDetails.Id;
            let testerId = params.UserId || loggedInUserId;
            let url = ['/Reports/TesterCertReport/', testerId].join('');
            if (this.state.userDetails.IsGroupTester) {
                // Group Tester users don't need the testerId in the url
                url = '/Reports/TesterCertReport';
            }
            this.location.path(url);
        };
        this.simTraceSummary = (params) => {
            let loggedInUserId = this.state.userDetails.Id;
            let testerId = params.UserId || loggedInUserId;
            if (this.state.selectedSim === null) {
                return;
            }
            let url = this.buildTraceSummaryPath(testerId, params.SimId, null);
            this.StateService.reset();
            this.StateService.selectedTester = {
                Id: params.UserId,
                Name: params.UserDescription
            };
            this.StateService.selectedSim = {
                Id: params.SimId,
                Name: params.SimName
            };
            this.location.path(url);
        };
        this.suiteTraceSummary = (params) => {
            let loggedInUserId = this.state.userDetails.Id;
            let testerId = params.UserId || loggedInUserId;
            let url = this.buildTraceSummaryPath(testerId, params.SimId, params.TestSuiteId);
            this.StateService.reset();
            this.StateService.selectedTester = {
                Id: params.UserId,
                Name: params.UserDescription
            };
            this.StateService.selectedSim = {
                Id: params.SimId,
                Name: params.SimName
            };
            this.StateService.selectedSuite = {
                Id: params.TestSuiteId,
                Name: params.TestSuiteName
            };
            this.location.path(url);
        };
        this.window = $window;
        this.uibModal = $uibModal;
        this.toastr = toastr;
        this.UserDetails = UserDetailsApi;
        this.browser = $browser;
        this.location = $location;
        this.moment = moment;
        this.ngProgressFactory = ngProgressFactory;
        this.SettingsService = SettingsExService;
        this.ReportServiceApi = ReportServiceApi;
        this.ReportService = ReportUtilityServiceApi;
        this.StateService = StateService;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('managementReport', {
    bindings: {},
    templateUrl: 'Scripts/App/partials/Reports/management-report.tpl.html',
    controllerAs: 'vm',
    controller: ManagementReportController
});
